import {FC, useEffect} from 'react';
import TabContext from '@mui/lab/TabContext';
import {resetActiveTab, useContractTabsSummaryStore} from '../../stores/contract-summary-tabs.store';
import {ContractSummaryHeader} from './contract-summary-header';
import {ContractSummaryPanels} from './contract-summary-panels';
import {Box, styled} from '@mui/material';
import {ContractsPaper} from '../contracts-paper';

export const ContractSummary: FC = () => {
  const activeTab = useContractTabsSummaryStore(({activeTab}) => activeTab);

  useEffect(() => resetActiveTab, []);

  return (
    <ContractsPaper>
      <Container>
        <TabContext value={activeTab}>
          <ContractSummaryHeader />
          <ContractSummaryPanels />
        </TabContext>
      </Container>
    </ContractsPaper>
  );
};

const Container = styled(Box)(({theme}) => ({
  padding: theme.spacing(2),
}));
